/**
 * Wraps a promise with a timeout. Rejects with an Error if the promise
 * doesn't resolve within `ms` milliseconds.
 */
export const withTimeout = <T>(
  promise: Promise<T>,
  ms: number,
  label: string
): Promise<T> => {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) =>
      setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms)
    ),
  ]);
};